/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - FONTS: STYLES --------------- ++++++++++ */
export default theme => ({
  fonts: {
  }
});
